// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import isEmpty from 'lodash/isEmpty';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;

export const ButtonList = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  @media ${(props) => props.theme.mediaQuery.medium} {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
`;

export const Button = styled(Anchor)`
  margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS}
    ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.LRCX};
  border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
  background-color: ${(props) => props.theme.colorPalette.gray[300]};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED}
    ${(props) => props.theme.spacing.ELEM_SPACING.XL};

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM}
      ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM}
      ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }
  ${(props) =>
    props.backgroundColor
      ? `
    background-color: ${props.backgroundColor};
  `
      : ``}
  ${(props) =>
    props.activePill
      ? `
    background-color: ${props.buttonColor};
    border: 1px solid ${props.backgroundColor};
  `
      : ``}
`;
